const dashboard = () => import('../views/purchase/dashboard.vue')
const purchasePdcList = () => import('../views/purchase/orders/pdc_index')
const purchaseItemList = () => import('../views/purchase/orders/item_index')
const purchaseShow = () => import('../views/purchase/orders/show')
const pdcList = () => import('../views/purchase/items/pdc_index')
const itemList = () => import('../views/purchase/items/item_index')
const purchaseOrderItemList = () => import('../views/purchase/order_items/index')
const materialList = () => import('../views/purchase/materials/index')

export default [
    {
        path: '/purchase/dashboard',
        component: dashboard,
        name: 'moduleDashboard',
        meta: {
            module_name: 'purchase',
        }
    },
    // {
    //     path: '/p/purchase_orders/pdc',
    //     component: purchasePdcList,
    //     meta: {
    //         module_name: 'purchase',
    //         en_name: 'purchasePurchasePdc',
    //         auth_id: 61101
    //     }
    // },
    {
        path: '/p/purchase_orders/pdc/:id',
        component: purchaseShow,
        meta: {
            module_name: 'purchase',
            en_name: 'purchasePurchasePdc',
            auth_id: 61105
        }
    },
    {
        path: '/p/purchase_orders/item',
        component: purchaseItemList,
        meta: {
            module_name: 'purchase',
            en_name: 'purchasePurchaseItem',
            auth_id: 61101
        }
    },
    {
        path: '/p/purchase_orders/item/:id',
        component: purchaseShow,
        meta: {
            module_name: 'purchase',
            en_name: 'purchasePurchaseItem',
            auth_id: 61105
        }
    },
    {
        path: '/p/materials',
        component: materialList,
        meta: {
            module_name: 'purchase',
            en_name: 'purchaseMaterial',
            auth_id: 61200
        }
    },
    // {
    //     path: '/p/pdcs',
    //     component: pdcList,
    //     meta: {
    //         module_name: 'purchase',
    //         en_name: 'purchasePdc',
    //         auth_id: 61200
    //     }
    // },
    // {
    //     path: '/p/items',
    //     component: itemList,
    //     meta: {
    //         module_name: 'purchase',
    //         en_name: 'purchaseItem',
    //         auth_id: 61200
    //     }
    // },
    {
        path: '/p/purchase_order_items',
        component: purchaseOrderItemList,
        meta: {
            module_name: 'purchase',
            en_name: 'purchasePurchaseOrderItem',
            auth_id: 61301
        }
    },
]
